import { useEffect, useState } from "react";
import clsx from "classnames";
import styles from "./styles.module.scss";

// Set on <html> while the banner is scrolled away, so the header's mobile menu
// can stop reserving space for it.
const HIDDEN_CLASS = "powered-by-banner-hidden";

const VertageLogo = () => (
  <svg
    className={styles.logo}
    viewBox="0 0 110.292 28"
    fill="currentColor"
    role="img"
    aria-label="Vertage"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M91.7207 19.4902C91.724 24.0342 88.1351 27.8079 83.5547 27.9932C80.7216 28.1067 78.1566 26.8216 76.5254 24.7529L79.4248 22.3164C80.3258 23.5216 81.7846 24.3452 83.4023 24.2803C85.5794 24.192 87.2694 22.8862 87.8584 20.5615C89.4861 19.6704 90.8307 18.327 91.7207 16.6982V19.4902ZM91.7188 7.0918H83.21C80.5995 7.0919 78.4834 9.31396 78.4834 12.0557C78.4834 14.7974 80.5994 17.0194 83.21 17.0195C85.8206 17.0195 87.9375 14.7975 87.9375 12.0557V8.27344H91.7188V12.0557C91.7188 16.7551 87.9095 20.5645 83.21 20.5645V20.5635C78.5105 20.5568 74.7012 16.754 74.7012 12.0547C74.7012 7.35531 78.5105 3.54599 83.21 3.5459H91.7188V7.0918ZM25.7256 3.5459C30.4251 3.5459 34.2354 7.35525 34.2354 12.0547C34.2354 12.5376 34.2234 12.9864 34.1826 13.4727H21.1338C21.7172 15.556 23.5508 17.0771 25.7246 17.0771C27.4262 17.0771 29.0013 16.2006 29.8506 14.7969L32.9551 16.8604C31.4308 19.1497 28.6824 20.5635 25.7246 20.5635C21.0252 20.5634 17.2159 16.754 17.2158 12.0547C17.2158 7.3553 21.0252 3.54599 25.7246 3.5459H25.7256ZM51.3662 13.9766C51.3662 15.9022 52.6844 17.0508 54.3398 17.0508H54.3408C54.7455 17.0507 55.3198 16.9491 55.6572 16.8477L55.8604 20.1572C55.3199 20.4285 54.5422 20.5635 53.833 20.5635C50.1847 20.5634 47.584 18.2328 47.584 14.1455V8.27246H51.3662V13.9766ZM101.782 3.5459C106.482 3.54591 110.291 7.35525 110.291 12.0547H110.292C110.292 12.5376 110.281 12.9864 110.24 13.4727H97.1904C97.7739 15.556 99.6084 17.0771 101.782 17.0771C103.484 17.0771 105.059 16.2007 105.908 14.7969L109.013 16.8604C107.488 19.1497 104.74 20.5635 101.782 20.5635C97.0827 20.5635 93.2735 16.7541 93.2734 12.0547C93.2734 7.35525 97.0827 3.5459 101.782 3.5459ZM72.9287 7.09082H64.4189C61.8086 7.09103 59.6926 9.31319 59.6924 12.0547C59.6924 14.7964 61.8085 17.0193 64.4189 17.0195C67.0295 17.0195 69.1465 14.7965 69.1465 12.0547V8.27344H72.9287V15.5996C72.9287 16.3816 73.5647 17.0186 74.3467 17.0186V20.3271C72.6427 20.3271 71.1456 19.495 70.2158 18.2852C68.6872 19.7144 66.6611 20.5658 64.4189 20.5625C59.7196 20.5557 55.9102 16.753 55.9102 12.0537C55.9103 7.3545 59.7197 3.54513 64.4189 3.54492H72.9287V7.09082ZM43.6357 7.0918C41.29 7.09203 39.3809 9.23728 39.3809 11.583V20.3281H35.5996V11.583C35.5996 7.1517 39.2044 3.54611 43.6357 3.5459V7.0918ZM11.2812 20.3271H7.14746L14.3975 3.90039H18.5312L11.2812 20.3271ZM4.13379 3.90039L8.61914 14.0625L6.55176 18.7451L0 3.90039H4.13379ZM25.7236 7.03223C23.5498 7.03225 21.7153 8.55336 21.1318 10.6367H30.3154C29.732 8.55335 27.8975 7.03223 25.7236 7.03223ZM101.782 7.03223C99.6084 7.03223 97.7739 8.55335 97.1904 10.6367H106.374C105.791 8.55335 103.956 7.03224 101.782 7.03223ZM51.3643 3.5459H55.7861V7.0918H44.7461V3.5459H47.582V0H51.3643V3.5459Z" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    className={styles.arrow}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="square"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 13.5L13 3M4.5 2.5H13.5V11.5" />
  </svg>
);

export const PoweredByBanner = ({
  customClass = "",
  text = "Lorien is now powered by",
  buttonTitle = "Find out more",
  buttonLink = "https://www.vertage.com/resources/news/headfirst-global-becomes-vertage-work-orchestration-platform",
  hideAfter = 300,
}) => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    let frame = null;

    const update = () => {
      frame = null;
      setIsHidden(window.scrollY > hideAfter);
    };

    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [hideAfter]);

  useEffect(() => {
    document.documentElement.classList.toggle(HIDDEN_CLASS, isHidden);
    return () => document.documentElement.classList.remove(HIDDEN_CLASS);
  }, [isHidden]);

  return (
    <div
      className={clsx(styles.root, isHidden && styles.hidden, customClass)}
      aria-hidden={isHidden || undefined}
    >
      <div className={styles.inner}>
        <p className={styles.text}>
          {text && <span>{text}&nbsp;</span>}
          <VertageLogo />
        </p>
        {buttonTitle && buttonLink && (
          <a
            className={styles.button}
            href={buttonLink}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={isHidden ? -1 : undefined}
          >
            <span>{buttonTitle}</span>
            <ArrowIcon />
          </a>
        )}
      </div>
    </div>
  );
};

export default PoweredByBanner;

// The banner renders inside the fixed header on the homepage, so the page
// content needs this spacer to clear the extra height. Both read the same
// --powered-by-banner-h, so the spacer always matches the rendered banner.
export function PoweredByBannerOffset() {
  return <div className={styles.offset} aria-hidden="true" />;
}
